import React from "react";
import styles from "./ContactPage1.module.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { useAuth } from "../../Common/Configurations/AuthContext";

const ContactPage1 = ({ branding, contactData, mode, onNavigate }) => {
  const { user } = useAuth();

  // 👇 DYNAMIC DATA LOGIC (Priority: DB Branding -> Auth Session -> Static Fallback)
  const phone = branding?.phone || user?.companyPhone || "9390465199";
  const email = branding?.email || user?.companyEmail || "contact@trawtel.com";
  const address = branding?.address || user?.companyAddress || "Main Office, Sector 5, India";
  
  // These usually come from the Template Blueprint (contactData prop)
  const title = contactData?.title || "Get In Touch";
  const description = contactData?.description || "Plan your next dream vacation with our travel experts.";
  const mapUrl = contactData?.mapIframeUrl || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.752538183201!2d78.3842188!3d17.4236531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI1JzI1LjIiTiA3OMKwMjMnMDMuMiJF!5e0!3m2!1sen!2sin!4v1634567890123";
  const officeHours = contactData?.officeHours || "Mon - Sat: 9:00 AM - 6:00 PM";

  return (
    <div className={styles.pageWrapper}>
      {/* 1. Page Header / Banner */}
      <div className={styles.banner}>
        <div className={styles.bannerOverlay}>
          <h1 className={styles.bannerTitle}>{title}</h1>
          <p className={styles.bannerText}>{description}</p>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.grid}>
          
          {/* 2. Contact Information Cards */}
          <div className={styles.infoColumn}>
            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaMapMarkerAlt /></div>
              <div className={styles.cardContent}>
                <h4>Office Location</h4>
                <p>{address}</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaPhoneAlt /></div>
              <div className={styles.cardContent}>
                <h4>Phone Number</h4>
                <p>{phone}</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaEnvelope /></div>
              <div className={styles.cardContent}>
                <h4>Email Address</h4>
                <p>{email}</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaClock /></div>
              <div className={styles.cardContent}>
                <h4>Office Hours</h4>
                <p>{officeHours}</p>
              </div>
            </div>
          </div>

          {/* 3. Google Maps Section */}
          <div className={styles.mapColumn}>
            <div className={styles.mapContainer}>
              <iframe
                src={mapUrl}
                className={styles.mapFrame}
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* 4. Builder-Only Back Button */}
    
      </div>
    </div>
  );
};

export default ContactPage1;